import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { DataTable } from 'seagull';
import { Edit } from 'seagull/icons';
import { draftRowActions } from '~/components/DraftActions/DraftRowMenuActions';
import { useDraftRowActionsFor } from '~/components/DraftActions/useDraftRowActionsFor';
import { routes } from '~/constants';
import { useTableColumnMenu } from '~/hooks/useTableColumnMenu';
import { useLocaleKeys } from '~/i18n';
import { DraftStatusType } from '~/models/DraftModel';
import { useStoreActions } from '~/store/store-context';
import { useDraftRows } from './hooks/useDraftRows';
const DRAFT_COLUMN_NAMES = [
    'companyName',
    'modifiedBy',
    'lastModified'
];
export function DraftsTable(param) {
    let { drafts, pagination, changedDraftIds, refresh, sort, onSortChange, selection, testId } = param;
    var _DRAFT_COLUMN_NAMES_sort_colIndex;
    const { t: draftsTexts } = useLocaleKeys('proposal.draftsDashboard');
    const { t: rowTexts } = useLocaleKeys('proposal.draftsDashboard.row');
    const { logBI } = useStoreActions();
    const navigate = useNavigate();
    const rows = useDraftRows(drafts);
    const titleOf = (row)=>[
            row.draft.title
        ];
    const mainColumn = {
        type: 'text',
        name: 'companyName',
        header: draftsTexts.companyName(),
        width: {
            initial: 240,
            min: 240
        },
        weight: 'normal',
        subtitle: titleOf,
        sortable: true,
        bi: {
            name: 'company_name'
        }
    };
    const columns = [
        {
            type: 'text',
            name: 'modifiedBy',
            header: draftsTexts.modifiedBy(),
            width: {
                initial: 160,
                min: 160
            },
            sortable: true,
            bi: {
                name: 'modified_by'
            }
        },
        {
            type: 'text',
            name: 'lastModified',
            header: draftsTexts.lastModified(),
            width: {
                initial: 140,
                min: 140
            },
            sortable: true,
            bi: {
                name: 'last_modified'
            }
        }
    ];
    const actionsFor = useDraftRowActionsFor({
        refresh
    });
    const columnMenu = useTableColumnMenu('drafts');
    const handlersFor = (draft)=>{
        const isScheduled = draft.status.type === DraftStatusType.Scheduled;
        return {
            isScheduled,
            handlers: actionsFor({
                draftId: draft.id,
                isSample: draft.isSample,
                isScheduled
            })
        };
    };
    const actionsForDraft = (draft)=>{
        const { isScheduled, handlers } = handlersFor(draft);
        // WHY: the floating bar owns Edit; on a card the bar folds into the sheet, so the kebab list never repeats it.
        return draftRowActions({
            isScheduled,
            handlers: _object_spread_props(_object_spread({}, handlers), {
                onEdit: undefined
            }),
            rowTexts,
            draftsTexts
        });
    };
    const menuFor = (row)=>actionsForDraft(row.draft);
    const openDraft = (draftId)=>{
        logBI(10352);
        navigate(routes.draft(draftId));
    };
    return /*#__PURE__*/ _jsx(DataTable, {
        pagination: pagination,
        allowColumnResize: true,
        allowColumnReorder: true,
        reorderBi: {
            name: 'drafts_reorder_columns'
        },
        allowColumnHide: true,
        columnMenu: columnMenu,
        testId: testId,
        items: rows,
        getRowId: (row)=>row.id,
        mainColumn: mainColumn,
        columns: columns,
        mobile: {
            fields: [
                {
                    name: 'modifiedBy',
                    label: draftsTexts.modifiedBy(),
                    hideColon: true,
                    joinWith: 'lastModified'
                }
            ]
        },
        rowHeapId: ()=>'draft',
        isRowEntering: (row)=>changedDraftIds.has(row.id),
        onRowClick: (row)=>openDraft(row.id),
        selection: selection,
        sort: {
            name: (_DRAFT_COLUMN_NAMES_sort_colIndex = DRAFT_COLUMN_NAMES[sort.colIndex]) !== null && _DRAFT_COLUMN_NAMES_sort_colIndex !== void 0 ? _DRAFT_COLUMN_NAMES_sort_colIndex : 'lastModified',
            direction: sort.sort === 'asc' ? 'asc' : 'desc',
            onChange: (next)=>onSortChange({
                    colIndex: DRAFT_COLUMN_NAMES.indexOf(next.name),
                    sort: next.direction
                })
        },
        rowActions: {
            inline: (row)=>[
                    {
                        icon: Edit,
                        label: rowTexts.edit(),
                        heapId: 'draft-view-btn',
                        onClick: handlersFor(row.draft).handlers.onEdit,
                        bi: {
                            name: 'draft_edit'
                        }
                    }
                ],
            menu: (row)=>menuFor(row),
            menuBi: {
                name: 'draft_actions'
            },
            menuHeapId: 'draft-menu-btn'
        }
    });
}
